import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

function App() {
  const [empresas, setEmpresas] = useState([]);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  useEffect(() => {
    const fetchEmpresas = async () => {
      const { data, error } = await supabase
        .from("vista_directorio")
        .select("razon_social, logo, pagina_web, telefono")
        .or("scomite1.eq.17,scomite2.eq.17,scomite3.eq.17,scomite4.eq.17")
        .order("razon_social", { ascending: true });

      if (error) {
        console.error("Error al obtener datos:", error);
      } else {
        setEmpresas(data);
      }
    };

    fetchEmpresas();
  }, []);

  return (
    <div className="relative">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6 p-4">
        {empresas.map((empresa, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl shadow-md p-4 flex flex-col items-center transform transition duration-300 hover:scale-105 hover:shadow-xl"
          >
            <img
              src={empresa.logo || "/img/nologo.jpg"}
              alt={empresa.razon_social}
              className="h-24 object-contain mb-4 transition duration-300"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = "/img/nologo.jpg";
              }}
            />

            <h3 className="text-center text-lg font-bold text-gray-800 m-4">
              {empresa.razon_social}
            </h3>

            {empresa.pagina_web ? (
              <a
                href={empresa.pagina_web}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 font-semibold hover:underline"
              >
                → Ver más
              </a>
            ) : (
              <button
                onClick={() => setEmpresaSeleccionada(empresa)}
                className="text-blue-600 font-semibold hover:underline"
              >
                → Ver más
              </button>
            )}
          </div>
        ))}
      </div>

      {empresaSeleccionada && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 transition-opacity duration-300">
          <div className="bg-white rounded-2xl shadow-lg p-6 w-80 text-center relative transform transition-all duration-300 scale-100 hover:scale-105">

            <h2 className="text-xl font-bold mb-4 text-green-700">
              Medios de contacto
            </h2>

            <div className="flex items-center justify-center gap-2 text-lg text-gray-700 mb-4">
              <span className="text-green-600 text-2xl">📞</span>
              <span
                className="px-3 py-1 rounded-full bg-green-100 text-green-800 font-semibold"
              >
                {empresaSeleccionada.telefono || "No disponible"}
              </span>
            </div>

            <button
              onClick={() => setEmpresaSeleccionada(null)}
              className="mt-4 bg-green-600 text-white px-5 py-2 rounded-lg shadow hover:bg-green-700 transition duration-300"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
